export default __webpack_public_path__ + "static/media/createNewKahshIcon1.cfc881de.png";